export const THUMBNAIL_SIZE = 90;
export const FLEXBOX_GAP = 10;
//# sourceMappingURL=constants.js.map